import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import { getMeURL } from '../utils/api';

const useGetMe = () => {
        
    const { auth } = useAuth();
    const [ gettingMe, setGettingMe ] = useState(false);
    const [ me, setMe ] = useState([]);
    const [ gettingMeReqSuccess, setGettingMeReqSuccess ] = useState(false);
    const [ unauthorized, setUnauthorized ] = useState(false);

    useEffect(() => {

        if (gettingMe) {
            axios.get(getMeURL, 
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                }
            }).then(result => {
                setGettingMe(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    setGettingMeReqSuccess(true);
                    setMe(data);         
                } else {
                    // console.log(result.data.errors);
                    // if (setErrors) {
                    //     setErrors(result.data.errors);
                    // }
                    setGettingMeReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    // if (setErrors) {
                    //     setErrors(['Could not connect to server']);
                    // }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    setUnauthorized(true);
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    // if (setErrors) {
                    //     setErrors([e.response.data.errors]);
                    // }
                }
                setGettingMeReqSuccess(false);
                setGettingMe(false);
            });
        }
    }, [gettingMe]);

    return { me, gettingMe, setGettingMe, gettingMeReqSuccess, unauthorized };
}

export default useGetMe;